import { createFlagRow } from "@mnk/shared/models/flagRow";
import type { RowData } from "./parseDataRows";

const roundType = (row: RowData) => {
  if (row.C === "上り") {
    return "Upbound";
  }

  return "Downbound";
};

const honsenOrRampType = (row: RowData) => {
  if (row.D === "本線") {
    return "Honsen";
  }

  return "Ramp";
};

const placeType = (row: RowData) => {
  if (row.E === "路肩") {
    return "Rokata";
  }

  if (row.E === "中分") {
    return "Chubun";
  }

  if (row.E === "側道") {
    return "Sokudo";
  }

  return "Unknown";
};

const numToDate = (num: string | null) => {
  if (!num) return null;

  // Excelの日付は1900年1月1日からの経過日数
  // 1900年1月1日からの経過日数を計算して日付に変換する
  const date = new Date(1900, 0, -1);
  date.setDate(date.getDate() + Number(num));
  return date;
};

const parseKiloPost = (data: string | number | null) => {
  if (data == null) return null;

  if (typeof data === "string") return null;

  return data;
};

/**
 * エクセルファイルからFlagを構築する
 */
export const buildFlag = (quantityId: string, row: RowData, sortOrder: number) => {
  const roadType = roundType(row);
  const honsenOrRamp = honsenOrRampType(row);

  const flagRow = createFlagRow({
    quantityId,
    roadType,
    honsenOrRamp,
    icJCTName: row.G,
    rampName: row.H,
    startKiloPost: parseKiloPost(row.I),
    modifiedStartKiloPost: parseKiloPost(row.J),
    endKiloPost: parseKiloPost(row.L),
    modifiedEndKiloPost: parseKiloPost(row.M),
    dateFirst: numToDate(row.P),
    dateSecond: numToDate(row.Q),
    dateThird: numToDate(row.R),
    dateFourth: numToDate(row.S),
    placeType: placeType(row),
    sortOrder,
  });

  return {
    flagRow,
    flagColumn: [],
    flagAction: [],
  };
};
